import { backendAPI } from '../../helper/apis';

export const FETCH_POLYGONS = 'FETCH_POLYGONS';

export function fetchPolygons(serviceId, areaId) {
  return {
    type: FETCH_POLYGONS,
    payload: backendAPI.get(`/v2/polygons/${serviceId}/${areaId}`)
  }
}